const el = '.kb-component--page-id-init'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (!DOM || DOM.length < 1) {
        console.warn(
            'No page id init found. The page id from the store will therefore not be set'
        )
        return false
    }

    if (DOM.length > 1) {
        throw new Error('Found multiple page id inits')
    }

    Store.dispatch('main/setPageId', DOM[0].dataset.pageId)
}
